import React, { FunctionComponent } from 'react'
import { Navigate, useRoutes } from 'react-router'

import { CheckoutProvider } from './CheckoutProvider'
import { useCheckoutConfig } from './useCheckoutConfig'
import { useStartCheckoutPath } from './useStartCheckoutPath'

export const CheckoutRouter: FunctionComponent = () => {
  const checkoutConfigs = useCheckoutConfig()

  const firstPath = useStartCheckoutPath()

  return useRoutes([
    {
      path: '*',
      element: <CheckoutProvider checkoutConfigs={checkoutConfigs} />,
      children: [
        {
          index: true,
          element: <Navigate to={firstPath} replace />,
        },
        ...checkoutConfigs.map(({ path, element }) => ({ path, element })),
        {
          path: '*',
          element: <Navigate to={`../${firstPath}`} replace />,
        },
      ],
    },
  ])
}
